import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  Inject,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { LogoService, ToastAlertService } from '@core/services';
import { TypeOfJob, WorkPlaceGroup } from '../../../models';
import { RoleService, WorkplaceGroupService } from '../../../services';
import { WorkplaceTypeService } from '../../../services/workplace-type.service';
import { WorkplaceService } from '../../../services/workplace.service';
import { ModalAlertComponent } from '@shared/components';
import { EditJobComponent } from '../edit-job/edit-job.component';
import { SafeUrl } from '@angular/platform-browser';
import { QRCodeElementType, QRCodeModule } from 'angularx-qrcode';
import { selectLogo } from '@store/selectors';
import { Store } from '@ngrx/store';
import { Pdfgqr } from '../../../models/pdfgqr.model';
import { PdfgenerateqrService } from '../../../services/pdfgenerateqr.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TitleComponent } from '@shared/components/title/title.component';
import { Cookies } from 'typescript-cookie';

@Component({
  styles: [
    `
      .green-button {
        background-color: #4caf50;
        color: white;
      }
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px; /* Ajusta el margen inferior según sea necesario */
      }

      .checkbox-item {
        font-size: 1.2rem;
        cursor: pointer;
        margin-bottom: 10px; /* Ajusta el espacio entre los checkboxes y el texto según sea necesario */
      }

      .checkbox-item.checked {
        color: #4caf50;
        font-weight: bold;
      }
      .day-checkboxes {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 20px;
      }

      .checkbox-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .checkbox-item mat-checkbox {
        margin-bottom: 5px;
      }
    `,
  ],
  templateUrl: './info-job.component.html',
  standalone: true,
  imports: [
    TitleComponent,
    MatFormFieldModule,
    MatListModule,
    MatCheckboxModule,
    MatDialogContent,
    QRCodeModule,
    MatDialogActions,
    MatButtonModule,
    RouterLink,
    MatIconModule,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class InfoJobComponent implements OnInit {
  issParking = signal(0);
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InfoJobComponent>,
    private PdfgenerateqrService: PdfgenerateqrService
  ) {
    this.dialogRef.disableClose = true;
    console.log('Editar', this.data);
    if (this.data.isparking === '1') {
      this.issParking.set(1);
    }
  }

  private destroyRef = inject(DestroyRef);
  private roleService = inject(RoleService);
  private workplaceGroupService = inject(WorkplaceGroupService);
  private workplaceTypeService = inject(WorkplaceTypeService);
  private workplaceService = inject(WorkplaceService);
  private dialog = inject(MatDialog);
  private messenger = inject(ToastAlertService);
  private readonly store = inject(Store);
  public readonly logo = this.store.selectSignal(selectLogo);
  private logoService = inject(LogoService);
  private alerService = inject(ToastAlertService);
  isSysAdmin = false;
  //Qr
  elementType = 'canvas' as QRCodeElementType;
  qrCodeDownloadLink: SafeUrl = '';
  workplaceGroups: WorkPlaceGroup[] = [];
  ptypeJobs: TypeOfJob[] = [];
  dataGroup: WorkPlaceGroup = {
    workplaceid: 0,
    name: '',
    description: '',
    id: 0,
  };
  dataTypeJob: TypeOfJob = {
    workplacetypeid: 0,
    name: '',
    description: '',
    recurrence: 0,
    maxcapacity: 0,
    isparking: '',
    blockstatus: 0,
    icon: '',
    color: '',
  };

  monday_ = this.data.action.monday == 1;
  tuesday_ = this.data.action.tuesday == 1;
  wednesday_ = this.data.action.wednesday == 1;
  thursday_ = this.data.action.thursday == 1;
  friday_ = this.data.action.friday == 1;
  saturday_ = this.data.action.saturday == 1;
  sunday_ = this.data.action.sunday == 1;

  ngOnInit(): void {
    this.chargueWorkplaceGrop();
    this.chargueTypeJob();
    this.loadqrService();
    this.ChargeRoleWorker();
  }

  //*Tipos de puestos de trabajo
  chargueWorkplaceGrop() {
    this.workplaceGroupService
      .getWorkplaces()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.workplaceGroups = resp.reply || [];
            for (const group of this.workplaceGroups) {
              if (group.id == this.data.action.workplacegroupid) {
                this.dataGroup = group;
                break;
              }
            }
          }
        },
      });
  }

  chargueTypeJob() {
    this.workplaceTypeService
      .getWorkplaces(this.data.businessId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.ptypeJobs = resp.reply || [];
            for (const typeJob of this.ptypeJobs) {
              if (typeJob.workplacetypeid == this.data.action.workplacetypeid) {
                this.dataTypeJob = typeJob;
              }
            }
          } else {
            this.alerService.error(resp.detail);
          }
        },
      });
  }

  ChargeRoleWorker() {
    const role = Cookies.get('role');
    console.log(role);
    if (role != null) {
      if (role == 'SYSADMIN') {
        this.isSysAdmin = false;
      } else {
        this.isSysAdmin = true;
      }
      console.log(this.isSysAdmin);
    }
  }

  modalDelete(data: any) {
    let dialogDelete;
    if (this.data.isparking === '1') {
      dialogDelete = this.dialog.open(ModalAlertComponent, {
        data: `el puesto de parqueo ${data.name}`,
      });
    } else {
      dialogDelete = this.dialog.open(ModalAlertComponent, {
        data: `el puesto de trabajo ${data.name}`,
      });
    }
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;
        this.workplaceService
          .deleteWorkplace(data.workplaceid)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.code === 10000) {
                this.messenger.sucess(
                  'Puesto de trabajo eliminado correctamente'
                );
                this.dialogRef.close('recargar');
              } else {
                this.messenger.error(resp.detail);
              }
            },
          });
      });
  }

  //*Open modal for Edit Job
  editJob(data: any) {
    const dialogEdit = this.dialog.open(EditJobComponent, {
      width: '40rem',
      height: '45rem',
      data: {
        action: data,
        idfloor: this.data.idfoor,
        isparking: this.data.isparking,
        businessId: this.data.businessId,
      },
    });
    dialogEdit
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result == 'recargar') {
          this.dialogRef.close('recargar');
        }
      });
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  imgsysadmin = '';
  loadqrService() {
    this.logoService.getOneLogo(this.data.logo_id).subscribe({
      next: ({ reply }) => {
        this.imgsysadmin = reply.value;
      },
    });
  }

  dowloandQr() {
    let valuelogo = this.logo() && this.logo()[0] && this.logo()[0].value;
    if (!valuelogo) {
      valuelogo = this.imgsysadmin;
    }
    const dataqr: Pdfgqr = {
      name: this.data.action.name,
      qrdata: this.data.action.workplaceid,
      width: 208,
      logo: valuelogo,
      type: this.data.action.type,
    };

    // Crear un arreglo que contiene el objeto
    const datos: Pdfgqr[] = [dataqr];
    // Luego, puedes asignar este arreglo al servicio
    const datoServiceInstance = this.PdfgenerateqrService;
    datoServiceInstance.dato = datos;
    this.dialogRef.close('cerrar');
  }

  reserve() {
    this.dialogRef.close('cerrar');
  }
}
